<template>
  <div>
    <div class="rank-item-icon"></div>
    <div class="popular-index">
      <h1>{{ topTitle }}</h1>
      <p class="curr-rank">
        本期({{ nowPeriodInfo.startTime }}-{{ nowPeriodInfo.endTime }})
      </p>
      <!-- <p class="curr-rank">第{{ nowPeriodInfo.periods }}期({{ nowPeriodInfo.startTime }}-{{ nowPeriodInfo.endTime }})</p> -->
      <div class="rankitem" v-if="noExist">
        <div class="nfh-img-box">
          <img
            :src="rankItem.columnIcon || defaultImg"
            alt=""
            class="nfh-img"
          />
          <img
            :src="goldIcon"
            class="nfh-img-gold"
            v-if="rankItem.isGoldColumn"
          />
        </div>
        <div class="nfh-content" v-if="isRankItemInit && !isRankItemError">
          <p class="nfh-name">{{ rankItem.columnName }}</p>
          <p class="nfh-num">
            <i class="fire-icon"></i><span>{{ rankItem.popularVal }}人气</span>
          </p>
          <p class="nfh-rank">
            <span class="label">目前排名</span>
            <span class="rank" v-if="rankItem.rank <= 30">{{
              `NO.${rankItem.rank}`
            }}</span>
            <span class="not" v-if="rankItem.rank > 30">未上榜</span>
          </p>
          <div class="nfh-btn" @click="handleHit">
            {{ isRankItemHasHit ? "再次打榜" : "打榜" }}
          </div>
        </div>

        <div class="nfh-content center" v-if="isRankItemError">
          <p>{{ rankItemErrorTip }}</p>
        </div>
      </div>
      <div v-if="noExist">
        <p class="rank-tips">*分享页每天可为同一个南方号打榜一次+1票</p>
        <p class="rank-tips">*打开南方+，可再打榜+2票</p>
      </div>

      <div class="rule_btn" @click="goRule()">打榜规则</div>
      <div class="index_wrap">
        <div class="index_wrap_caption">
          <img src="../img/star_icon@2x.png" />
          <span>本期榜单</span>
          <img src="../img/star_icon@2x.png" />
        </div>
        <nfh-item
          v-for="(list, index) in lists"
          :nfh="list"
          @popSupport="popSupport"
          :key="list.id"
          :index="index"
          :isLatest="isLatest"
          :hitList="hitList"
          :cityRankInfo="cityRankInfo"
          @getUuid="getHitList"
        ></nfh-item>
        <div v-if="!lists || lists.length == 0" class="no_data">暂无数据~</div>
      </div>
      <support
        v-show="showSupport"
        @popSupport="popSupport"
        :nfh="supportObj"
        :cityRankInfo="cityRankInfo"
        :tipsMsg="tipsMsg"
      />
    </div>
  </div>
</template>
<script>
import { initShare } from "@/js/shareWx.js";
import { shareUrl, shareTitle, shareDesc, shareIcon } from "@/js/shareInfo.js";
import { newOpenApp } from "@/js/newOpenApp";
import nfhItem from "@/components/popularItem.vue";
import support from "@/components/support.vue";
import { nanfangIfUrl } from "@/js/url";
// import { getAllUrlParams } from "@/js/main.js";
import getParamsFromUrl from "@/js/getParamsFromUrl";
import defaultImg from "@/img/nfh_logo.png";
import goldIcon from "@/img/nfhGoldIcon1.png";
import { wxAuth, getUuid } from "@/js/wx";
import weui from "weui.js";
export default {
  data() {
    return {
      lists: [],
      periods: [],
      nowPeriod: -1,
      latestPeriod: 0,
      nowPeriodInfo: {},
      isLatest: true,
      nowLabel: "本期榜单",
      showSupport: false,
      supportObj: {},
      hitList: [],
      tipsMsg: "",
      hasGetUuid: false,
      rankItem: {},
      isRankItemHasHit: false,
      isRankItemInit: false,
      isRankItemError: false,
      rankItemErrorTip: "网络竟然崩溃了",
      uuid: "",
      catId: "",
      topTitle: "",
      noExist: false,
      cityRankInfo: {},
      defaultImg,
      goldIcon
    };
  },
  created() {
    getUuid(uuid => {
      this.uuid = uuid;
    });
    const nfhId = this.$route.query.nfhId;
    this.catId = this.$route.query.catId;
    nfhId ? this.getPopular(nfhId) : this.$router.replace({ path: "/" });
    this.getPeriods();
    getUuid(this.getHitList);
  },
  mounted(){
    this.getAppStyle()
  },
  methods: {
    handleHit() {
      const self = this;
      function isWeixinBrowser() {
        let ua = navigator.userAgent.toLowerCase();
        return /micromessenger/.test(ua);
      }

      if (this.isRankItemHasHit) {
        newOpenApp(
          self.$route.query.nfhId,
          "cityRank",
          false,
          this.cityRankInfo,
          24
        );
      } else {
        if (isWeixinBrowser()) {
          wxAuth(function(uuid) {
            $.ajax({
              url: `${nanfangIfUrl}/nfh/popular/hit`,
              type: "POST",
              dataType: "json",
              data: {
                columnId: self.rankItem.columnId,
                uuid
              },
              success: res => {
                if (res.code === 200) {
                  self.popSupport({
                    bool: true,
                    nfh: self.rankItem
                  });
                  self.isRankItemHasHit = true;
                  self.rankItem.popularVal = self.rankItem.popularVal + 1;
                } else if (res.code === 400) {
                  self.popSupport({
                    bool: true,
                    nfh: self.rankItem,
                    tipsMsg: "每天只能打榜一次"
                  });
                  self.isRankItemHasHit = true;
                } else if (res.code === 403) {
                  self.popSupport({
                    bool: true,
                    nfh: self.rankItem,
                    tipsMsg: "打榜失败，请重试"
                  });
                  window.localStorage.removeItem("wxUserUuid");
                }
              }
            });
          });
        } else {
          newOpenApp(
            self.$route.query.nfhId,
            "cityRank",
            false,
            this.cityRankInfo,
            24
          );
        }
      }
    },
    changeShareInfo({ title, desc, icon }) {
      //阻止页面刷新
      try {
        activity.setReloadWhileOnPause(false);
      } catch (e) {}
      const shareData = {
        //请求失败回调
        getShareFail: () => {
          console.log("微信请求调用失败");
        },
        url: window.location.origin + "/" + window.location.hash,
        //分享标题
        title: title || shareTitle,
        //分享描述
        desc: desc || shareDesc,
        //分享图片地址
        iconUrl: icon || shareIcon
      };
      initShare(shareData);
    },
    popSupport({ bool, nfh = {}, tipsMsg = "打榜成功！票数+1" }) {
      this.showSupport = bool;
      this.supportObj = nfh;
      // this.supportObj.catId = this.catId
      // this.supportObj.articleId = this.articleId
      // console.log('this.supportObj',this.supportObj)
      this.tipsMsg = tipsMsg;
    },
    getPopular(nfhId) {
      const self = this;
      $.ajax({
        url: `${nanfangIfUrl}/nfh/popular/getPopularByCat`,
        type: "GET",
        dataType: "json",
        data: {
          nfhId: nfhId,
          catId: this.catId,
          // uuid:'62183564-0d69-4f9d-b904-1cad740cb951'
          uuid: this.uuid
        },
        success(res) {
          const { data, code, msg } = res;
          if (code === 200) {
            self.isRankItemInit = true;
            self.rankItem = data;
            self.changeShareInfo({
              title: `你的好友正在为“${data.columnName}”打榜拉票中，快来助力！`,
              icon: data.columnIcon || shareIcon
            });
            self.noExist = true;
          } else {
            self.isRankItemError = true;
            self.rankItemErrorTip = msg;
            self.noExist = false;
          }
        },

        error() {
          self.isRankItemError = true;
          self.rankItemErrorTip = "网络竟然崩溃了";
        }
      });
    },
    getPeriods() {
      $.ajax({
        url: `${nanfangIfUrl}/nfh/popular/periods`,
        type: "GET",
        dataType: "json",
        data: {},
        success: res => {
          let data, nowPeriod;
          if (res.code === 200) {
            data = res.data.list;
            this.periods = data.map(item => {
              return {
                label: `第${item.periods}期榜单（${item.startTime}-${
                  item.endTime
                }）`,
                value: item.periods
              };
            });
            nowPeriod = data[0] ? data[0].periods : 1;
            this.latestPeriod = nowPeriod; //记录最新一期
            this.nowPeriod = nowPeriod;
            this.nowPeriodInfo = data[0];
            //this.getNowPeriod(nowPeriod);
          }
        }
      });
    },
    getHitList(uuid) {
      if (this.hasGetUuid) return;
      this.hasGetUuid = true;
      $.ajax({
        url: `${nanfangIfUrl}/nfh/popular/getHitList`,
        type: "POST",
        dataType: "json",
        data: {
          uuid: uuid
        },
        success: res => {
          if (res.code === 200) {
            this.hitList = res.data;

            if (this.hitList.indexOf(this.$route.query.nfhId) > -1) {
              this.isRankItemHasHit = true;
            }
          }
        }
      });
    },
    goRule() {
      //跳转打榜规则页面
      this.$router.push({ path: "/rule", query: { catName: this.catName } });
    },
    selectPeriod() {
      let self = this;
      weui.picker(this.periods, {
        container: "#index",
        defaultValue: [this.nowPeriod],
        onChange: function(result) {
          console.log(result);
        },
        onConfirm: function(result) {
          console.log(result);
          if (self.latestPeriod == result[0].value) {
            self.isLatest = true;
          } else {
            self.isLatest = false;
          }
          self.nowPeriod = result[0].value;
          self.nowLabel = result[0].label;
        }
      });
    },
    // 获取人气榜top30
    getNowPeriod(nowPeriod) {
      // let url = 'https://devstatic.nfnews.com/apptpl/hotArticleShare/#/rankitem?nfhId=2220&catId=1&articleId=283534'
      const params = getParamsFromUrl();
      this.catId = params.catId;
      this.articleId = params.articleId;
      this.cityRankInfo.catId = params.catId;
      this.cityRankInfo.articleId = params.articleId;
      $.ajax({
        url: `${nanfangIfUrl}/nfh/popular/listPopularTopThirty`,
        type: "GET",
        dataType: "json",
        data: {
          periods: nowPeriod,
          catId: params.catId,
          articleId: params.articleId
        },
        success: this.getNowPeriodSuc
      });
    },
    getNowPeriodSuc(res) {
      if (res.code === 200) {
        this.lists = res.data.topList;
        this.topTitle = res.data.article.title;
        this.catName = res.data.catName;
      }
      if (res.code === 404) {
        window.location.href =
          "https://static.nfnews.com/apptpl/new404.html";
      }
    },

    async getAppStyle() {
      let that = this;
      $.ajax({
        url: `${nanfangIfUrl}/app/getAppStyle`,
        type: "GET",
        dataType: "json",
        success: function(result) {
          console.log("==222==", result);
          if (result.code === 200) {
            that.getDetailsStyle(result.data);
          }
        }
      });
    },
    async getDetailsStyle(appStyleInfo) {
      console.log("------", appStyleInfo);
      // 获取dom节点
      const domEl = document.getElementsByTagName("html")[0];
      if (appStyleInfo && +appStyleInfo.themeType === 1) {
        // 全局黑白
        if (this.hasClass(domEl, "notgrayscale")) {
          this.removeClass(domEl, "notgrayscale");
        }
        this.addClass(domEl, "grayscale");
      } else {
        // 全局彩色
        if (this.hasClass(domEl, "grayscale")) {
          this.removeClass(domEl, "grayscale");
        }
        this.addClass(domEl, "notgrayscale");
      }
    },
    hasClass(curEle, className) {
      var reg = new RegExp("(^| +)" + className + "( +|$)");
      return reg.test(curEle.className);
    },
    addClass(curEle, className) {
      var arr = className.replace(/(^ +| +$)/g, "").split(/ +/g); // 先去首尾空格，为了防止className为多个类名 "box1 box2"
      for (var i = 0, len = className.length; i < len; i++) {
        var curName = arr[i];
        if (!this.hasClass(curEle, className)) {
          if (i === 0) {
            curEle.className += "" + curName;
          } else {
            curEle.className += " " + curName;
          }
        }
      }
    },
    removeClass(curEle, className) {
      var arr = className.replace(/(^ +| +$)/g, "").split(/ +/g);
      for (var i = 0, len = className.length; i < len; i++) {
        var curName = arr[i];
        if (this.hasClass(curEle, curName)) {
          var reg = new RegExp("(^| +)" + curName + "( +|$)", "g");
          curEle.className = curEle.className.replace(reg, " ");
        }
      }
    }
  },
  watch: {
    nowPeriod(newVal, oldVal) {
      this.getNowPeriod(newVal);
    }
  },
  components: {
    "nfh-item": nfhItem,
    support
  }
};
</script>
<style lang="less">
@import url("../less/mixin.less");
@import url("../less/my_weui.css");
@import url("../less/font_size.less");
.rank-item-icon {
  position: absolute;
  top: 0;
  width: 100%;
  height: 2.04rem;
  background-image: url("../img/img_bg@2x.png");
  background-size: cover;
  z-index: 1;
}

.popular-index {
  // position: relative;
  margin-bottom: 0.6rem;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  .bg-image("../img/list_bg");
  height: 100%;
  .rankitem {
    position: relative;
    margin: 0 auto 0.2rem;
    width: 5.2rem;
    height: 3.72rem;
    border-radius: 5px;
    background-color: #fff;

    .nfh-img-box {
      position: absolute;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1rem;
      height: 1rem;
      transform: translate(-50%, -235%);

      .nfh-img {
        width: 1rem;
        height: 1rem;
        border: 1px solid #eee;
        border-radius: 50%;
      }

      .nfh-img-gold {
        position: absolute;
        bottom: -0.05rem;
        right: -0.05rem;
        width: 0.36rem;
        height: 0.36rem;
      }
    }

    .nfh-content.center {
      padding: 0;
      width: inherit;
      height: inherit;
      justify-content: center;

      > p {
        font-size: 0.3rem;
      }
    }

    .nfh-content {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-top: 0.7rem;

      .nfh-name {
        width: 80%;
        font-size: 0.34rem;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .nfh-num {
        font-size: 0.22rem;
        color: #999;
        .fire-icon {
          display: inline-block;
          width: 0.2rem;
          height: 0.24rem;
          .bg-image("../img/red_hot_icon");
          margin-right: 5px;
        }
      }

      .nfh-rank {
        margin-top: 0.3rem;
        font-size: 0.3rem;

        .label {
          color: #666;
        }

        .rank {
          color: #f64e45;
          font-weight: bold;
        }

        .not {
          color: #999;
        }
      }

      .nfh-btn {
        margin-top: 0.3rem;
        width: 1.6rem;
        height: 0.7rem;
        background-color: #f64e45;
        font-size: 0.32rem;
        text-align: center;
        line-height: 0.7rem;
        color: #fff;
        border-radius: 5px;
      }
    }
  }

  h1 {
    margin-top: 0.3rem;
    font-size: 0.52rem;
    font-weight: 400;
    text-align: center;
    color: #fff;
  }

  .curr-rank {
    margin-bottom: 0.8rem;
    font-size: 0.26rem;
    text-align: center;
    color: #bb3b14;
    transform: translateY(-2px);
  }

  .rank-tips {
    margin: 0 auto;
    width: 5.2rem;
    font-size: 0.26rem;
    color: #ffffff;
  }

  .rule_btn {
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 0.7rem;
    width: 1.6rem;
    height: 0.72rem;
    line-height: 0.65rem;
    font-size: 0.26rem;
    color: #bb3b14;
    text-align: right;
    padding-right: 0.2rem;
    .bg-image("../img/Rectangle2");
    cursor: pointer;
  }
  .title_bg {
    position: absolute;
    left: 1.8rem;
    right: 1.5rem;
    top: 0.35rem;
    height: 1.55rem;
    .bg-image("../img/champion_list_bg");
  }
  .index_wrap {
    box-sizing: border-box;
    position: relative;
    //top: 2.04rem;
    // width: 6.9rem;
    margin: 0.8rem auto 0.6rem;
    min-height: 9.5rem;
    background-color: #fff;
    border-radius: 4px;
    .index_wrap_caption {
      position: relative;
      top: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0 0.3rem;
      font-size: 0.3rem;
      color: #d03304;

      > img {
        margin: 0 0.2rem;
        width: 0.3rem;
        vertical-align: middle;
      }
    }
    .period_select {
      position: absolute;
      top: -0.14rem;
      left: 1rem;
      right: 1rem;
      height: 0.6rem;
      .bg-image("../img/title_list_bg");
      display: flex;
      justify-content: center;
      align-items: center;
      /*font-size: 0.3rem;*/
      font-weight: bold;
      color: #d03304;
      cursor: pointer;
      &:before {
        content: "";
        display: block;
        position: absolute;
        width: 0.28rem;
        height: 0.26rem;
        .bg-image("../img/star_icon");
        top: 50%;
        left: -0.28rem;
      }
      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 0.28rem;
        height: 0.26rem;
        .bg-image("../img/star_icon");
        top: 50%;
        right: -0.28rem;
      }
      .select_down_arrow {
        display: inline-block;
        width: 0.2rem;
        height: 0.1rem;
        .bg-image("../img/down_arrow_icon");
      }
    }
    .no_data {
      width: 100%;
      height: 20px;
      line-height: 20px;
      font-size: 0.26rem;
      text-align: center;
      color: #ccc;
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/RankItem.vue